/**
 * Shared status mapping for Dashboard filtering.
 * Groupings here should match the backend logic for calculating summary counts.
 */

export const STATUS_GROUPS = {
  active: [
    "QUALIFIED",
    "OPEN",
    "WORKING",
    "ATTEMPTEDCONTACT",
    "NEEDSFOLLOWUP",
    "NOTENGAGED",
  ],
  inactive: ["NEWOPPORTUNITY", "DISQUALIFIED"],
  converted: {
    lead: ["CONVERTTOCUSTOMER", "CONVERTTOLEAD"],
    customer: ["CONVERTTOCUSTOMER"],
    vendor: ["CONVERTTOVENDOR", "CONVERTTOCUSTOMER"],
  },
};

/**
 * Filter a list of records based on category and module.
 * @param {Array} data - List of records (leads, customers, or vendors)
 * @param {string} category - 'total', 'active', 'inactive', or 'converted'
 * @param {string} module - 'lead', 'customer', or 'vendor'
 * @returns {Array} Filtered list
 */
export const filterByStatus = (data, category, module) => {
  if (!category || category === "total") return data;

  const getNormalizedStatus = (status) =>
    status ? String(status).trim().toUpperCase() : "";

  if (category === "converted") {
    const allowedStatuses = STATUS_GROUPS.converted[module].map((s) =>
      s.toUpperCase(),
    );
    return data.filter((item) =>
      allowedStatuses.includes(getNormalizedStatus(item.status)),
    );
  }

  const statuses = STATUS_GROUPS[category];
  if (!statuses) return data;

  const normalizedAllowedStatuses = statuses.map((s) => s.toUpperCase());
  return data.filter((item) =>
    normalizedAllowedStatuses.includes(getNormalizedStatus(item.status)),
  );
};
